export default __webpack_public_path__ + "static/media/micimg4.d32cda3e.webp";